<script lang="ts">
    import { useNavigate } from 'svelte-navigator';
    import { IS_AUTHENTICATED, IS_ORGANIZATION_APPROVED, CAMPAIGN_TOKEN } from '@smatch/cassiopeia-web-components';

    const navigate = useNavigate();

    const onAuthenticationChange = (isAuthenticated: boolean, isApproved: boolean): void => {

        if ($CAMPAIGN_TOKEN !== undefined && isAuthenticated) {
            return;
        }

        if (isAuthenticated && isApproved) {
            return;
        }

        if (isAuthenticated && !isApproved) {
            navigate('/onboarding');
            return;
        }

        const URL = window.location.href.replace(window.location.origin, '');

        // eslint-disable-next-line @typescript-eslint/naming-convention
        navigate(`/authentication?url=${ URL }`, { replace: true });
    };

    $: onAuthenticationChange($IS_AUTHENTICATED, $IS_ORGANIZATION_APPROVED);

</script>

{#if ($IS_AUTHENTICATED && $IS_ORGANIZATION_APPROVED) || $CAMPAIGN_TOKEN !== undefined}
    <slot />
{/if}